import {useHistoryPageState} from '@aboutyou/history-page-state';
import {Grid} from '@aboutyou/ui-components';
import {range} from '@aboutyou/utils';
import React, {FC} from 'react';
import styled from 'styled-components';
import {
  StreamPaddingCSS,
  labelToProductImageType,
} from '../../../features/ProductStream/helpers';
import {useProductStreamStatus} from '../../../features/ProductStream/utils';
import {ProductStreamOffsetLimitPagination} from '../../../features/ProductStreamPagination/ProductStreamOffsetLimitPagination';
import {useShallowRenderingState} from '../../../features/ProductTile/utils';
import {useAdditionalProductsByPage} from '../utils/useAdditionalProductsByPage';
import {AdditionalTilesByPage} from './AdditionalTilesByPage';
import {ProductStreamProps} from './ProductStream';

const HISTORY_STATE_ADDITIONAL_CURRENT_PAGE_KEY =
  'category_additional_product_stream_current_page';
const HISTORY_STATE_LAST_VISIBLE_ITEMS_KEY =
  'category_additional_product_stream_last_visible_items';

export const AdditionalProductStream: FC<ProductStreamProps> = ({
  renderingPriority,
  gridColumns,
  preferredProductImageType,
  inlineBASPlacements,
  loadMoreComponentDisplayConfig,
  constrainStoryTilesToViewportBoundary,
  onClickAddCta,
  ProductTileComponent,
  layoutConfig,
}) => {
  const [currentAdditionalPage, setCurrentAdditionalPage] = useHistoryPageState(
    1,
    {
      uniqueKey: HISTORY_STATE_ADDITIONAL_CURRENT_PAGE_KEY,
    },
  );
  const shallowRenderingState = useShallowRenderingState({
    uniqueKey: HISTORY_STATE_LAST_VISIBLE_ITEMS_KEY,
  });
  const {isNextPageReady} = useProductStreamStatus({
    currentPage: currentAdditionalPage,
    useRequest: useAdditionalProductsByPage,
  });

  return (
    <>
      <StyledGrid
        columns={gridColumns}
        enableEnhancedTileRendering
        uniqueKey="additionalProductStream"
      >
        {range(1, currentAdditionalPage + 1).map(page => (
          <AdditionalTilesByPage
            renderingPriority={renderingPriority}
            page={page}
            key={page}
            gridColumns={gridColumns}
            preferredProductImageType={labelToProductImageType(
              preferredProductImageType,
            )}
            inlineBASPlacements={inlineBASPlacements}
            constrainStoryTilesToViewportBoundary={
              constrainStoryTilesToViewportBoundary
            }
            onClickAddCta={onClickAddCta}
            shallowRenderingState={shallowRenderingState}
            ProductTileComponent={ProductTileComponent}
            layoutConfig={layoutConfig}
          />
        ))}
      </StyledGrid>
      {isNextPageReady && (
        <ProductStreamOffsetLimitPagination
          currentPage={currentAdditionalPage}
          setCurrentPage={setCurrentAdditionalPage}
          loadMoreComponentDisplayConfig={loadMoreComponentDisplayConfig}
        />
      )}
    </>
  );
};

const StyledGrid = styled(Grid)`
  ${StreamPaddingCSS}
`;
